import { __decorate } from "tslib";
import { singleton } from 'mana-syringe';

var OffscreenCanvasCreator =
/** @class */
function () {
  function OffscreenCanvasCreator() {}

  OffscreenCanvasCreator.prototype.getOrCreateCanvas = function () {
    if (this.canvas) {
      return this.canvas;
    }

    try {
      // OffscreenCanvas2D measureText can be up to 40% faster.
      // @ts-ignore
      this.canvas = new window.OffscreenCanvas(0, 0);
      this.context = this.canvas.getContext('2d');

      if (!this.context || !this.context.measureText) {
        this.canvas = document.createElement('canvas');
        this.context = this.canvas.getContext('2d');
      }
    } catch (ex) {
      this.canvas = document.createElement('canvas');
      this.context = this.canvas.getContext('2d');
    }

    this.canvas.width = 10;
    this.canvas.height = 10;
    return this.canvas;
  };

  OffscreenCanvasCreator.prototype.getOrCreateContext = function () {
    if (this.context) {
      return this.context;
    }

    this.getOrCreateCanvas();
    return this.context;
  };

  OffscreenCanvasCreator = __decorate([singleton()], OffscreenCanvasCreator);
  return OffscreenCanvasCreator;
}();

export { OffscreenCanvasCreator };